import { Children, cloneElement } from 'react';

export default function StudyExpectationsMissingDocuments(props) {

    const {
        children,
        missingExpectedStudyDocuments,
        missingExpectedStaffDocuments,
        binderId,
        studyStage,
        studyTeam,
        onError,
        onFile,
        openFilePicker,
        setUploadedFileToExpectation,
        setTeamMemberIdUpload,
    } = props;

    return cloneElement(Children.only(children),
        {
            expectedStudyDocuments: missingExpectedStudyDocuments,
            expectedStaffDocuments: missingExpectedStaffDocuments,
            binderId,
            studyStage,
            studyTeam,
            onError,
            onFile,
            openFilePicker,
            setUploadedFileToExpectation,
            setTeamMemberIdUpload,
        }
    );
}

